module.exports = __webpack_public_path__ + "static/media/se.b92b605a.svg";